export default __webpack_public_path__ + "static/media/13 Track 13.635db02e.mp3";